import { render, staticRenderFns } from "./CallRecords.vue?vue&type=template&id=0bf34ef4&scoped=true"
import script from "./CallRecords.vue?vue&type=script&lang=js"
export * from "./CallRecords.vue?vue&type=script&lang=js"
import style0 from "./CallRecords.vue?vue&type=style&index=0&id=0bf34ef4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf34ef4",
  null
  
)

export default component.exports